/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Rows_Listing_FeatureInputs */

const en_directory_comparison_product_hunt_rows_listing_feature = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Listing_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing shape`)
};

const zh_directory_comparison_product_hunt_rows_listing_feature = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Listing_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面形态`)
};

/**
* | output |
* | --- |
* | "Listing shape" |
*
* @param {Directory_Comparison_Product_Hunt_Rows_Listing_FeatureInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_rows_listing_feature = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Rows_Listing_FeatureInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Rows_Listing_FeatureInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_rows_listing_feature(inputs)
	return zh_directory_comparison_product_hunt_rows_listing_feature(inputs)
});
export { directory_comparison_product_hunt_rows_listing_feature as "directory.comparison.product_hunt.rows.listing.feature" }